import { SceneKey } from './sceneKeys';
import { GameMode } from '../types/GameMode';

/** 対戦モード選択画面のボタン設定 */
export interface BattleModeSelectButtonConfig {
  /** ボタンのラベルテキスト */
  label: string;
  /** 遷移先シーン */
  targetScene: SceneKey;
  /** ゲームモード */
  mode?: GameMode;
}

/** 対戦モード選択画面ラベル */
export const BATTLE_MODE_SELECT_LABELS = {
  title: 'モード選択',
} as const;

/** モード選択画面のボタン定義（表示順） */
export const BATTLE_MODE_SELECT_BUTTONS: BattleModeSelectButtonConfig[] = [
  {
    label: 'キャンペーン',
    targetScene: SceneKey.STAGE_SELECT,
    mode: GameMode.CHALLENGE,
  },
  {
    label: 'サバイバル',
    targetScene: SceneKey.CHARACTER_SELECT,
    mode: GameMode.SURVIVAL,
  },
  {
    label: '対戦',
    targetScene: SceneKey.VERSUS_SELECT,
  },
  {
    label: '大会',
    targetScene: SceneKey.TOURNAMENT_SETUP,
  },
  {
    label: '戻る',
    targetScene: SceneKey.TITLE,
  },
];
